export class FabProcessStep {
    id!: string
    indexId!: number
    name!: string
    sortOrder!: number
    colorHex!: string
    leadTimeDays!: number
    progressWeight!: number
    category!: string
    active!: boolean
    modifiedDate?: Date | string
    modifiedByUserId?: string
}
